import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var ja = {
  language: 'ja',
  country: 'jp',
  name: '日本語',
  embeddedLocale: merge(error, login),
  flags: ['JP'],
};

export { ja as default };
